import DaoStyleCore from '@dao-style/core';
import { setFetchAcceptLanguage } from '@/plugins/fetch/request';
import { importWithLocaleFallback } from './locale-utils';

export async function loadExternalLanguage(lang: string) {
  const { module: extendModule } = await importWithLocaleFallback(
    lang,
    (l) => import(`@dao-style/extend/dist/locales/${l}.js`),
    { fallback: 'en-US' },
  );
  const daoStyleExtend = (extendModule as { default: unknown })?.default;
  const daoStyleCore = DaoStyleCore.locale(lang);

  return [
    daoStyleExtend,
    daoStyleCore,
  ].filter(Boolean);
}

// 单独拆出来方便cli-plugin修改
export async function setI18nLanguageExternal(lang: string) {
  setFetchAcceptLanguage(lang);

  const html = document.querySelector('html');

  html?.setAttribute('lang', lang);
}
